const API_PATH = "/api/v1/boletaDigital";
const DEFAULT_LOCAL_API_ROOT = "http://localhost:4000";

const normalizeRoot = (root) => String(root || "").replace(/\/+$/, "");

export const getApiBaseUrl = () => {
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }

  const apiRoot = normalizeRoot(
    process.env.REACT_APP_API_ROOT || DEFAULT_LOCAL_API_ROOT
  );
  return `${apiRoot}${API_PATH}`;
};

export const getApiOrigin = () => {
  try {
    return new URL(getApiBaseUrl()).origin;
  } catch {
    return "http://localhost:4000";
  }
};
